import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "@theprelude/core";
import { useState } from "react";

export const usePopover = () => {
  const [open, onOpenChange] = useState(false);
  return { open, onOpenChange };
};

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;
export const PopoverArrow = PopoverPrimitive.Arrow;

export const PopoverContent: React.FC<PopoverPrimitive.PopoverContentProps> = ({
  children,
  className,
  sideOffset = 8,
  ...props
}) => {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        {...props}
        sideOffset={sideOffset}
        className={cn(
          "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-bottom-2 data-[side=top]:slide-in-from-top-2 data-[side=left]:slide-in-from-left-2 data-[side=right]:slide-in-from-right-2 z-40 overflow-hidden rounded border border-stroke-line bg-surface-background data-[state=closed]:animate-out data-[state=open]:animate-in",
          className,
        )}
      >
        {children}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  );
};
